.root {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 18px;
  border-radius: var(--radius-md);
  background: var(--color-danger-soft);
  border: 1px solid rgba(164, 41, 31, 0.18);
  max-width: 520px;
}

.icon {
  color: var(--color-danger);
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}

.copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
}

.detail {
  font-size: 13px;
  color: var(--color-text-secondary);
  line-height: 1.5;
}
